export default __webpack_public_path__ + "dd8a2474ba4877f62beb27761ed4a260.png";